import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Switcher, { SwitcherOption } from '../../../../ui/Switcher'
import { FormValues } from '../index'

const periodOptions: SwitcherOption[] = [
	{ label: 'Monthly', value: 'month' },
	{ label: 'Yearly', value: 'year' },
]

const PeriodSwitcher: React.FC = () => {
	const { control } = useFormContext<FormValues>()

	return (
		<Controller
			control={control}
			name="period"
			render={({ field: { value, onChange } }) => (
				<div className="mb-6">
					<Switcher
						options={periodOptions}
						value={value}
						onChange={onChange}
						className="w-fit"
					/>
				</div>
			)}
		/>
	)
}

export default PeriodSwitcher
